import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visibleEditOption: false,
  stepNo: 0,
};

const motivatesYouSlice = createSlice({
  name: "discProfiling",
  initialState,
  reducers: {
    saveVisibleEditOption(state, action) {
      state.visibleEditOption = action.payload;
    },
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
  },
});

export const { saveVisibleEditOption, saveStepNo } = motivatesYouSlice.actions;

export default motivatesYouSlice.reducer;
